import styled from "styled-components";
import { CSSObjectWithLabel, Theme, ThemeConfig } from "react-select";
import { theme as themeStyled } from "styled-tools";
import theme from "../../Contexts/ThemeProvider";
import mediaQuery, { Screen } from "../../Utilities/MediaQuery";

export const ErrorContainer = styled.div`
  color: ${themeStyled("Amaranth_Red")};
  display: flex;
  align-items: end;
  padding: 0 8px;
`;

export const ErrorMessage = styled.div`
  font-size: 16px;
  margin-left: 8px;
  font-family: "Montserrat";
`;

export const Label = styled.label`
  display: block;
  width: 100%;
  color: ${theme.Dark_Silver};
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  font-family: "Montserrat";
  line-height: normal;
  padding-bottom: 16px;
  padding-left: 5px;
  text-align: left;

  ${mediaQuery[Screen.mobile]} {
    font-size: 16px;
  }
`;

export const selectStyles = {
  control: (): CSSObjectWithLabel => ({
    padding: "8px 10px",
    borderWidth: "1px",
    borderStyle: "solid",
    borderRadius: "12px",
    boxSizing: "border-box",
    display: "flex",
    borderColor: theme.Silver_Sand,
    textAlign: "left",
    ":focus-within": {
      borderWidth: "2px",
      borderColor: theme.Onyx,
    },
  }),
};

export const selectTheme: ThemeConfig = (defaultTheme): Theme => ({
  ...defaultTheme,
  colors: {
    ...defaultTheme.colors,
    primary: theme.Black,
  },
});

export const SelectContainer = styled.div`
  max-width: 650px;
  padding-block: 24px;
`;

export const Asterisk = styled.span`
  color: ${theme.Amaranth_Red};
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  font-family: "Montserrat";
  margin: 3px 4px 0px -12px;
`;
